'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPhoneLocked = function MdPhoneLocked(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32 6.6v-0.7c0-1.6-1.3-2.9-2.9-2.9s-2.8 1.3-2.8 2.9v0.7h5.7z m1.4 0c0.9 0 1.6 0.8 1.6 1.8v6.6c0 0.9-0.7 1.6-1.6 1.6h-8.4c-0.9 0-1.6-0.7-1.6-1.6v-6.6c0-1 0.7-1.8 1.6-1.8v-0.7c0-2.3 1.9-4.3 4.1-4.3s4.3 2 4.3 4.3v0.7z m0 19.3c0.9 0 1.6 0.7 1.6 1.6v5.9c0 0.9-0.7 1.6-1.6 1.6-15.7 0-28.4-12.7-28.4-28.4 0-0.9 0.7-1.6 1.6-1.6h5.9c0.9 0 1.6 0.7 1.6 1.6 0 2.2 0.4 4.1 1 6 0.1 0.5 0.1 1.2-0.4 1.7l-3.7 3.7c2.4 4.7 6.3 8.6 11 11l3.7-3.7c0.5-0.5 1.2-0.5 1.7-0.4 1.9 0.7 3.9 1 6 1z' })
        )
    );
};

exports.default = MdPhoneLocked;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/phone-locked.js
// module id = 3395
// module chunks = 0